import React from 'react';

export function WorkOutlineIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M28 12V8h-8v4h8zM8 16v22h32V16H8zm32-4c2.22 0 4 1.78 4 4v22c0 2.22-1.78 4-4 4H8c-2.22 0-4-1.78-4-4l.02-22c0-2.22 1.76-4 3.98-4h8V8c0-2.22 1.78-4 4-4h8c2.22 0 4 1.78 4 4v4h8z" />
    </svg>
  );
}
